// @flow
// Libs
import React, { Component } from 'react'
import _get from 'lodash/get'

// Components
import InputRange from 'react-input-range'
import InteractiveSelect from './InteractiveSelect'

// Styles
import './inputRange.scss'
import commonStyles from './style'

// Types
type Props = {
  operation: Object,
  config: Object,
  selectedFeatureIndices: Array<number>,
  styles: Object,
  stylingClasses: string,
  onChange: Function,
}

class SelectWithRange extends Component {
  props: Props
  static defaultProps = {
    selectedFeatureIndices: [],
    styles: {},
    stylingClasses: '',
  }

  constructor (props: Props) {
    super(props)

    const gridData = _get(props, 'operation.model.gridData', {})
    const value = _get(props, `operation.model.gridData.grid.transformations.${props.config.VALUE_LABEL}`,
      props.config.DEFAULT_VALUE)
    const isModelUpdateNeeded = props.selectedFeatureIndices.some((featureIndex: number): boolean => {
      const featureModelValue = _get(gridData, `grid[${featureIndex}][${props.config.VALUE_LABEL}]`)

      return featureModelValue !== value
    })

    this.options = []

    for (let i = props.config.MIN_VALUE; i <= props.config.MAX_VALUE; i += props.config.STEP) {
      this.options.push({
        value: i,
        label: i,
      })
    }

    this.state = {
      value,
      selectedOption: this.getSelectedOption(value),
    }

    if (isModelUpdateNeeded) {
      this.updateGridModel(value)
    }

    this.onChange = this.onChange.bind(this)
  }

  getSelectedOption (value: number): Object {
    return this.options.find((opt: Object): boolean => opt.value === value)
  }

  onChange (value: number) {
    const selectedOption = this.getSelectedOption(value)

    this.setState({
      value,
      selectedOption,
    })

    this.updateGridModel(value)
  }

  updateGridModel (value: number) {
    const features = {}
    const model = _get(this.props, 'operation.model', {})
    const gridData = _get(this.props, 'operation.model.gridData', {})
    const grid = _get(this.props, 'operation.model.gridData.grid', {})

    this.props.selectedFeatureIndices.forEach((featureIndex: number) => {
      features[featureIndex] = {
        ...gridData.grid[featureIndex],
        [this.props.config.VALUE_LABEL]: value,
      }
    })

    this.props.onChange({
      ...this.props.operation,
      model: {
        ...model,
        gridData: {
          ...gridData,
          grid: {
            ...grid,
            ...features,
            transformations: {
              ...grid.transformations,
              [this.props.config.VALUE_LABEL]: value,
            },
          },
        },
      },
    })
  }

  render (): React.Element<any> {
    return (
      <div
        data-test={`grid-${this.props.config.VALUE_LABEL}`}
        style={{...commonStyles.container, ...this.props.styles.container}}>
        <label style={commonStyles.label} htmlFor={`grid-tool-${this.props.config.VALUE_LABEL}`}>
          {this.props.config.LABEL}
        </label>
        <InteractiveSelect
          config={this.props.config}
          value={this.state.value}
          options={this.options}
          selectedOption={this.state.selectedOption}
          onChange={this.onChange}
          getSelectedOption={this.getSelectedOption}
          stylingClasses={this.props.stylingClasses}
        />
        <div style={commonStyles.slider} className='range-no-value-label range-labels-aligned-inside'>
          <InputRange
            maxValue={this.props.config.MAX_VALUE}
            minValue={this.props.config.MIN_VALUE}
            value={this.state.value}
            step={this.props.config.STEP}
            onChange={this.onChange}
            draggableTrack
            maxLabel={null}
            minLabel={null}
            valueLabel={''}
          />
        </div>
      </div>
    )
  }
}

export default SelectWithRange
